/* Zentraler Katalog Gäste-Nachrichten-Templates.
   ZWEI getrennte Kataloge damit E-Mail (kurz + persönlich) und WhatsApp
   (lang + wie die Auto-Gmail-Templates) unterschiedlichen Ton haben können.

   Erwartete Row-Felder (alle optional, fallen sauber zurück):
     first_name / last_name / guest_name
     room_name / room?.name
     check_in / check_out / nights
     guest_email / guest_phone
     source
*/
import { OWNER_WHATSAPP } from "./messaging";

const CI_URL        = "https://mainspessartblick.de/check-in/";
const BREAKFAST_URL = "https://mainspessartblick.de/checkliste-fruehstueck/";
const MEALS_URL     = "https://mainspessartblick.de/mittag-und-abendessen/";
const REVIEW_URL    = "https://g.page/r/CT8oxZo2ut-fEBM/review";
const MAPS_URL      = "https://www.google.com/maps/search/?api=1&query=Ringstra%C3%9Fe+22b+97816+Lohr+am+Main";
const HOMEPAGE_URL  = "https://mainspessartblick.de";

const fmtDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = String(iso).split("-");
  return `${d}.${m}.${y}`;
};
const firstNameOf = (row) =>
  row.first_name ||
  (row.guest?.first_name) ||
  (row.guest_name || row.name || "").split(" ")[0] ||
  "";
const roomNameOf = (row) => row.room_name || row.room?.name || "";
const nightsOf   = (row) => row.nights || 0;

// ============================================================================
// EMAIL-TEMPLATES · KURZ + PERSÖNLICH (unverändert vom ursprünglichen Katalog)
// ============================================================================
const EMAIL_SIGN = "\n\nHerzliche Grüße\nIvan Giombini · MainSpessartBlick\nWhatsApp: " + OWNER_WHATSAPP;

export const EMAIL_TEMPLATE_CATALOG = [
  {
    key: "welcome_msb",
    label: "Welcome MSB",
    hint: "Vor Anreise: Bestätigung + Zimmer",
    build: (row) => ({
      subject: "Willkommen im MainSpessartBlick",
      body:
        `Hallo ${firstNameOf(row)},\n\n` +
        `vielen Dank für Ihre Buchung im MainSpessartBlick! ` +
        `Wir freuen uns sehr auf Ihren Aufenthalt vom ${fmtDate(row.check_in)} bis ${fmtDate(row.check_out)} ` +
        `im ${roomNameOf(row)}.\n\n` +
        `Sollten Sie Fragen zu Anreise, Parken oder Frühstück haben, melden Sie sich jederzeit direkt bei mir.` +
        EMAIL_SIGN,
    }),
  },
  {
    key: "checkin",
    label: "Check-In",
    hint: "1–2 Tage vorher: Zugangslink + Ablauf",
    build: (row) => ({
      subject: `Ihr Check-In für ${fmtDate(row.check_in)}`,
      body:
        `Hallo ${firstNameOf(row)},\n\n` +
        `wir freuen uns auf Ihre Anreise am ${fmtDate(row.check_in)}. ` +
        `Damit alles reibungslos klappt, bitte hier kurz die Meldedaten hinterlegen:\n` +
        `${CI_URL}\n\n` +
        `Nach dem Ausfüllen bekommen Sie den Türcode und die genaue Anreise-Info. ` +
        `Ihre Anreise ist ab 15:00 Uhr möglich.` +
        EMAIL_SIGN,
    }),
  },
  {
    key: "meals",
    label: "Frühstück / Abendessen",
    hint: "Vorbestellung für Verpflegung",
    build: (row) => ({
      subject: "Frühstück & Abendessen im MainSpessartBlick",
      body:
        `Hallo ${firstNameOf(row)},\n\n` +
        `wir bieten für Ihren Aufenthalt (${nightsOf(row)} ${nightsOf(row)===1?"Nacht":"Nächte"}) frisches ` +
        `Frühstück und auf Wunsch ein hausgemachtes Abendessen an.\n\n` +
        `Bitte kurz hier vorbestellen, damit wir alles frisch für Sie vorbereiten:\n` +
        `${BREAKFAST_URL}\n\n` +
        `Bei Allergien oder Wünschen schreiben Sie mir einfach kurz.` +
        EMAIL_SIGN,
    }),
  },
  {
    key: "postcheckout",
    label: "Nach Check-Out",
    hint: "Direkt nach Abreise: Danke + Feedback",
    build: (row) => ({
      subject: "Vielen Dank für Ihren Aufenthalt",
      body:
        `Hallo ${firstNameOf(row)},\n\n` +
        `vielen Dank, dass Sie im MainSpessartBlick zu Gast waren! ` +
        `Wir hoffen, Sie hatten eine erholsame Zeit im ${roomNameOf(row)} und dürfen Sie bald wieder begrüßen.\n\n` +
        `Falls Ihnen etwas besonders gefallen hat — oder auch nicht — freue ich mich über eine kurze Rückmeldung an mich persönlich.` +
        EMAIL_SIGN,
    }),
  },
  {
    key: "review",
    label: "Beurteilung",
    hint: "Bitte um Google-/Booking-Bewertung",
    build: (row) => {
      const isBookingCom = ((row.source || row.quelle) || "").toLowerCase().startsWith("booking");
      return {
        subject: "Vielen Dank für Ihren Aufenthalt bei MainSpessartBlick",
        body:
          `💚 Vielen Dank für Ihren Aufenthalt!\n\n` +
          `Hallo ${firstNameOf(row)},\n\n` +
          `wir möchten uns herzlich bei Ihnen bedanken, dass Sie sich für MainSpessartBlick entschieden haben. Es hat uns sehr gefreut, Sie als Gast begrüßen zu dürfen, und wir hoffen, dass Sie einen angenehmen Aufenthalt bei uns hatten.\n\n` +
          `Als kleine familiengeführte Unterkunft steckt in MainSpessartBlick sehr viel Herzblut, Zeit und Leidenschaft. Deshalb bedeutet uns jede Bewertung besonders viel. Mit Ihrer Unterstützung helfen Sie uns, weiter zu wachsen und auch zukünftig vielen Gästen eine schöne Zeit in Lohr am Main zu ermöglichen. Vielen Dank dafür!\n\n` +
          `⭐ Wenn Sie mit Ihrem Aufenthalt zufrieden waren, würden wir uns sehr über eine kurze Bewertung freuen:\n` +
          `👉 ${REVIEW_URL}\n\n` +
          (isBookingCom
            ? `🌐 Sollten Sie über Booking.com gebucht haben: Nach Ihrer Abreise erhalten Sie von Booking.com automatisch eine E-Mail zur Bewertung, oder Sie geben diese direkt über Ihr Booking-Konto ab.\n\n`
            : ``) +
          `Jede einzelne Bewertung bedeutet uns sehr viel und hilft unserer kleinen familiengeführten Unterkunft, noch mehr Gäste zu erreichen. Sollte einmal etwas nicht zu Ihrer vollsten Zufriedenheit gewesen sein, freuen wir uns selbstverständlich auch über eine direkte Nachricht. Ihr Feedback ist für uns besonders wertvoll.\n\n` +
          `Nochmals vielen Dank für Ihren Besuch. Vielleicht dürfen wir Sie ja schon bald wieder im MainSpessartBlick begrüßen.` +
          EMAIL_SIGN,
      };
    },
  },
  {
    key: "sonstiges",
    label: "Sonstiges",
    hint: "Freier Text (leere Vorlage)",
    build: (row) => ({
      subject: "Nachricht vom MainSpessartBlick",
      body:
        `Hallo ${firstNameOf(row)},\n\n` +
        `` +
        EMAIL_SIGN,
    }),
  },
];

// ============================================================================
// WHATSAPP-TEMPLATES · LANG + AUSFÜHRLICH (1:1 wie die Auto-Gmail-Templates)
// ============================================================================
const CONTACT_BLOCK =
  `📞 Telefon oder WhatsApp: +49 176 25799945\n` +
  `🌐 ${HOMEPAGE_URL}\n` +
  `📍 Ringstraße 22b · 97816 Lohr am Main\n` +
  `🗺️ ${MAPS_URL}`;

const WA_SIGN = `\n\nHerzliche Grüße\nIhr MainSpessartBlick Team\nIvan & Carolin Giombini · WhatsApp: ${OWNER_WHATSAPP}`;

export const WHATSAPP_TEMPLATE_CATALOG = [
  {
    key: "welcome_msb",
    label: "Welcome MSB",
    hint: "Buchungsbestätigung: gleicher Inhalt wie die Bestätigungs-E-Mail",
    remote: true,
    build: (row) => ({
      subject: `Buchungsbestätigung MainSpessartBlick · ${fmtDate(row.check_in)} → ${fmtDate(row.check_out)}`,
      body:
        `Hallo ${firstNameOf(row)},\n\n` +
        `vielen Dank für Ihre Buchung!\n` +
        `Wir freuen uns sehr, Sie bald als unseren Gast im MainSpessartBlick begrüßen zu dürfen.\n\n` +
        `📅 Ihre Buchungsdaten:\n` +
        `• Anzahl Übernachtungen: ${nightsOf(row)}\n` +
        `• Anreise: ${fmtDate(row.check_in)}\n` +
        `• Abreise: ${fmtDate(row.check_out)}\n` +
        (roomNameOf(row) ? `• Zimmer: ${roomNameOf(row)}\n` : "") +
        `\n` +
        `Damit wir Ihre Ankunft optimal vorbereiten können, teilen Sie uns bitte kurz Ihre voraussichtliche Ankunftszeit mit.\n\n` +
        `🏠 Adresse Ihrer Unterkunft:\n` +
        `MainSpessartBlick · Ringstraße 22b · 97816 Lohr am Main\n` +
        `🗺️ ${MAPS_URL}\n\n` +
        `Damit Ihre Anreise entspannt und der Check-in vor Ort schnell erledigt ist, empfehlen wir Ihnen, bereits vor Anreise das Online Check-in Formular auszufüllen:\n` +
        `✓ Online Check-In: ${CI_URL}\n\n` +
        `Außerdem können Sie bequem vor Anreise zusätzliche Leistungen auswählen:\n` +
        `🥐 Frühstück bestellen: ${BREAKFAST_URL}\n` +
        `🍽️ Mittag- & Abendessen bestellen: ${MEALS_URL}\n\n` +
        `Weitere Services über unsere Homepage:\n` +
        `✓ Online Check-In durchführen\n` +
        `✓ Frühstück bestellen\n` +
        `✓ Mittag- und Abendessen bestellen\n` +
        `✓ Buchungsanfragen und Preisinformationen\n` +
        `✓ Informationen zu Ihrem Aufenthalt\n` +
        `✓ Kontakt- und Anreiseinformationen\n\n` +
        `💬 Unser digitaler Assistent NIC hilft Ihnen jederzeit!\n` +
        `Unten rechts auf ${HOMEPAGE_URL} beantwortet NIC rund um die Uhr Fragen zu Aufenthalt, Check-in, Frühstück, WLAN, TV, Freizeit in Lohr am Main u.v.m.\n\n` +
        `Wir wünschen Ihnen bereits jetzt eine angenehme Anreise und freuen uns darauf, Sie bald bei uns begrüßen zu dürfen.\n\n` +
        CONTACT_BLOCK +
        WA_SIGN,
    }),
  },
  {
    key: "checkin",
    label: "Check-In",
    hint: "1-2 Tage vor Anreise: Erinnerung + Online-Check-in",
    build: (row) => ({
      subject: `Erinnerung — morgen bei MainSpessartBlick · ${fmtDate(row.check_in)}`,
      body:
        `Hallo ${firstNameOf(row)},\n\n` +
        `morgen dürfen wir Sie bei MainSpessartBlick begrüßen — wir freuen uns auf Ihren Besuch!\n\n` +
        `Falls noch nicht erledigt, empfehlen wir Ihnen, vor Ihrer Anreise unseren Online Check-In auszufüllen. So sparen Sie Zeit bei der Ankunft und wir können Ihren Aufenthalt optimal vorbereiten:\n` +
        `✓ Online Check-In: ${CI_URL}\n\n` +
        `Falls gewünscht, können Sie noch Frühstück sowie Mittag- und Abendessen vorbestellen:\n` +
        `🥐 Frühstück: ${BREAKFAST_URL}\n` +
        `🍽️ Mittag- & Abendessen: ${MEALS_URL}\n\n` +
        `⏰ Bitte teilen Sie uns außerdem kurz Ihre voraussichtliche Ankunftszeit mit.\n\n` +
        `💬 Bei Fragen hilft Ihnen unser virtueller Assistent NIC auf ${HOMEPAGE_URL}.\n\n` +
        `Wir wünschen Ihnen eine angenehme Anreise und freuen uns darauf, Sie morgen persönlich begrüßen zu dürfen.\n\n` +
        CONTACT_BLOCK +
        WA_SIGN,
    }),
  },
  {
    key: "meals",
    label: "Frühstück / Abendessen",
    hint: "Küche: Vorbestellung Frühstück + Mittag/Abend",
    build: (row) => ({
      subject: "Frühstück oder Abendessen morgen bei MainSpessartBlick? 🥐🍽️",
      body:
        `Hallo ${firstNameOf(row)},\n\n` +
        `wir freuen uns darauf, Sie morgen bei MainSpessartBlick zu begrüßen!\n\n` +
        `Sollten Sie noch Frühstück oder ein Mittag-/Abendessen für Ihren Aufenthalt (${nightsOf(row)} ${nightsOf(row)===1?"Nacht":"Nächte"}) wünschen, geben Sie uns bitte heute Bescheid, damit wir alles frisch einkaufen und vorbereiten können:\n\n` +
        `🥐 Frühstück bestellen: ${BREAKFAST_URL}\n` +
        `🍽️ Mittag- & Abendessen bestellen: ${MEALS_URL}\n\n` +
        `Falls Sie nichts davon möchten — auch kein Problem, dann einfach diese Nachricht ignorieren.\n\n` +
        `Bei Allergien oder Wünschen schreiben Sie uns einfach kurz.\n\n` +
        CONTACT_BLOCK +
        `\n\nBis morgen!\nIhr MainSpessartBlick Team\nIvan & Carolin Giombini · WhatsApp: ${OWNER_WHATSAPP}`,
    }),
  },
  {
    key: "postcheckout",
    label: "Nach Check-Out",
    hint: "Direkt nach Abreise: Danke von Herzen + Bewertung",
    build: (row) => {
      const isBookingCom = ((row.source || row.quelle) || "").toLowerCase().startsWith("booking");
      return {
        subject: "Vielen Dank für Ihren Aufenthalt bei MainSpessartBlick",
        body:
          `💚 Vielen Dank für Ihren Aufenthalt!\n\n` +
          `Hallo ${firstNameOf(row)},\n\n` +
          `wir möchten uns herzlich bei Ihnen bedanken, dass Sie sich für MainSpessartBlick entschieden haben. Es hat uns sehr gefreut, Sie als Gast begrüßen zu dürfen, und wir hoffen, dass Sie einen angenehmen Aufenthalt bei uns hatten.\n\n` +
          `Als kleine familiengeführte Unterkunft steckt in MainSpessartBlick sehr viel Herzblut, Zeit und Leidenschaft. Deshalb bedeutet uns jede Bewertung besonders viel. Mit Ihrer Unterstützung helfen Sie uns, weiter zu wachsen und auch zukünftig vielen Gästen eine schöne Zeit in Lohr am Main zu ermöglichen. Vielen Dank dafür!\n\n` +
          `⭐ Wenn Sie mit Ihrem Aufenthalt zufrieden waren, würden wir uns sehr über eine kurze Bewertung freuen:\n` +
          `👉 ${REVIEW_URL}\n\n` +
          (isBookingCom
            ? `🌐 Sie haben über Booking.com gebucht: Nach Ihrer Abreise erhalten Sie von Booking.com automatisch eine E-Mail zur Bewertung, oder Sie geben diese direkt über Ihr Booking-Konto ab.\n\n`
            : ``) +
          `Jede einzelne Bewertung bedeutet uns sehr viel und hilft unserer kleinen familiengeführten Unterkunft, noch mehr Gäste zu erreichen. Sollte einmal etwas nicht zu Ihrer vollsten Zufriedenheit gewesen sein, freuen wir uns selbstverständlich auch über eine direkte Nachricht. Ihr Feedback ist für uns besonders wertvoll.\n\n` +
          `Nochmals vielen Dank für Ihren Besuch. Vielleicht dürfen wir Sie ja schon bald wieder im MainSpessartBlick begrüßen.\n\n` +
          CONTACT_BLOCK +
          WA_SIGN,
      };
    },
  },
  {
    key: "review",
    label: "Beurteilung",
    hint: "Ausführliche Danke + Bewertungsbitte (wie Auto-Mail)",
    build: (row) => {
      const isBookingCom = ((row.source || row.quelle) || "").toLowerCase().startsWith("booking");
      return {
        subject: "Vielen Dank für Ihren Aufenthalt bei MainSpessartBlick",
        body:
          `💚 Vielen Dank für Ihren Aufenthalt!\n\n` +
          `Hallo ${firstNameOf(row)},\n\n` +
          `wir möchten uns herzlich bei Ihnen bedanken, dass Sie sich für MainSpessartBlick entschieden haben. Es hat uns sehr gefreut, Sie als Gast begrüßen zu dürfen, und wir hoffen, dass Sie einen angenehmen Aufenthalt bei uns hatten.\n\n` +
          `Als kleine familiengeführte Unterkunft steckt in MainSpessartBlick sehr viel Herzblut, Zeit und Leidenschaft. Deshalb bedeutet uns jede Bewertung besonders viel. Mit Ihrer Unterstützung helfen Sie uns, weiter zu wachsen und auch zukünftig vielen Gästen eine schöne Zeit in Lohr am Main zu ermöglichen. Vielen Dank dafür!\n\n` +
          `⭐ Wenn Sie mit Ihrem Aufenthalt zufrieden waren, würden wir uns sehr über eine kurze Bewertung freuen:\n` +
          `👉 ${REVIEW_URL}\n\n` +
          (isBookingCom
            ? `🌐 Sollten Sie über Booking.com gebucht haben: Nach Ihrer Abreise erhalten Sie von Booking.com automatisch eine E-Mail zur Bewertung, oder Sie geben diese direkt über Ihr Booking-Konto ab.\n\n`
            : ``) +
          `Jede einzelne Bewertung bedeutet uns sehr viel und hilft unserer kleinen familiengeführten Unterkunft, noch mehr Gäste zu erreichen. Sollte einmal etwas nicht zu Ihrer vollsten Zufriedenheit gewesen sein, freuen wir uns selbstverständlich auch über eine direkte Nachricht. Ihr Feedback ist für uns besonders wertvoll.\n\n` +
          `Nochmals vielen Dank für Ihren Besuch. Vielleicht dürfen wir Sie ja schon bald wieder im MainSpessartBlick begrüßen.\n\n` +
          CONTACT_BLOCK +
          WA_SIGN,
      };
    },
  },
  {
    key: "sonstiges",
    label: "Sonstiges",
    hint: "Freier Text (leere Vorlage mit Signatur)",
    build: (row) => ({
      subject: "Nachricht vom MainSpessartBlick",
      body:
        `Hallo ${firstNameOf(row)},\n\n` +
        `` +
        `\n\n` +
        CONTACT_BLOCK +
        WA_SIGN,
    }),
  },
];

// Rückwärtskompatibilität: alter Import `TEMPLATE_CATALOG` verweist auf E-Mail-Set
// (damit messaging.js autoSend + andere Legacy-Aufrufer nicht brechen).
export const TEMPLATE_CATALOG = EMAIL_TEMPLATE_CATALOG;

/** Buchungszeile → Row-Objekt kompatibel mit messaging.js autoSend */
export function bookingToRow(b) {
  return {
    id: b.id,
    first_name: b.guest?.first_name || "",
    last_name:  b.guest?.last_name  || "",
    guest_name: `${b.guest?.first_name || ""} ${b.guest?.last_name || ""}`.trim(),
    room_name:  b.room?.name || "",
    check_in:   b.check_in,
    check_out:  b.check_out,
    nights:     b.nights,
    source:     b.source || "",
    guest_email: b.guest?.email || "",
    guest_phone: b.guest?.phone || "",
  };
}
